// This module is based on jquery-ui/ui/scroll-parent.js

import $ from 'jquery';

export default function scrollParent( $el, includeHidden ) {
  var position = $el.css( "position" ),
    excludeStaticParent = position === "absolute",
    overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
    scrollParent = $el.parents().filter( function() {
      var parent = $( this );
      if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
        return false;
      }
      return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
    } ).eq( 0 );

  return position === "fixed" || !scrollParent.length ? $( $el[ 0 ].ownerDocument || document ) : scrollParent;
};
